export function filtered<T>(arr: (T | undefined | null)[]): T[] {
  return arr.filter(item => item ?? false) as T[];
}

export function toArray<T>(object: T | T[]): T[] {
  return Array.isArray(object) ? object : [object];
}
